<template>
  <div v-if="filterColumn">
    <div class="label-filter">{{ (filterColumn || {}).label }}</div>
    <component :is="filterColumn.input_component" v-model="filterColumn.value" v-bind="filterColumn"></component>
  </div>
</template>

<script>
import CustomerTypeSelect from "@/components/inputs/filter/customer-type-select";
import Datepicker from "@/components/inputs/datepicker";
import DatepickerRange from "@/components/inputs/filter/datepicker-range";
import DeliveryOrderMultiselectAjax from "@/components/inputs/filter/delivery-order-multiselect-ajax";
import DriverMultiselectAjax from "@/components/inputs/filter/driver-multiselect-ajax";
import FactoryMultiselectAjax from "@/components/inputs/filter/factory-multiselect-ajax";
import FarmerCustomerMultiselectAjax from "@/components/inputs/filter/farmer-customer-multiselect-ajax.vue";
import LocalMarketSaleOrderMultiselectAjax from "@/components/inputs/filter/local-market-sale-order-multiselect-ajax";
import LcsMultiselectAjax from "@/components/inputs/filter/lcs-multiselect-ajax";
import NumberRange from "@/components/inputs/filter/number-range";
import ProductServiceMultiselectAjax from "@/components/inputs/filter/product-service-multiselect-ajax";
import PurchaseOrderMultiselectAjax from "@/components/inputs/filter/purchase-order-multiselect-ajax";
import RangePrice from "@/components/inputs/range-price";
import SaleOrderMultiselectAjax from "@/components/inputs/filter/sale-order-multiselect-ajax";
import SaleOrderTypeSelect from "@/components/inputs/filter/sale-order-type-select";
import SupplierMultiselectAjax from "@/components/inputs/filter/supplier-multiselect-ajax";
import TicketMultiselectAjax from "@/components/inputs/filter/ticket-multiselect-ajax";
import TicketStatusSelect from "@/components/inputs/filter/ticket-status-select";
import TripMultiselectAjax from "@/components/inputs/filter/trip-multiselect-ajax";
import UserSelectAjax from "@/components/inputs/filter/user-select-ajax";
import VehicleMultiselectAjax from "@/components/inputs/filter/vehicle-multiselect-ajax";
import OdooPurchaseOrderStateSelect from "@/components/inputs/filter/odoo-purchase-order-state-select.vue";
import OdooPurchaseOrderInvoiceStatusSelect from "@/components/inputs/filter/odoo-purchase-order-invoice-status-select.vue";
import OdooSaleOrderStateSelect from "@/components/inputs/filter/odoo-sale-order-state-select.vue";
import OdooSaleOrderInvoiceStatusSelect from "@/components/inputs/filter/odoo-sale-order-invoice-status-select.vue";
import PartnerCustomerMultiselectAjax from "@/components/inputs/filter/partner-customer-multiselect-ajax.vue";
import ProcessingCustomerMultiselectAjax from "@/components/inputs/filter/processing-customer-multiselect-ajax.vue";
import PurchaseOrderPaymentStatusSelect from "@/components/inputs/filter/purchase-order-payment-status-select";
import PurchasePaymentStatusSelect from "@/components/inputs/filter/purchase-payment-status-select";
import SalesInvoicePaymentStatusSelect from "@/components/inputs/filter/sales-invoice-payment-status-select";
import SalesReportPaymentStatusSelect from "@/components/inputs/filter/sales-report-payment-status-select";
import BalancingMultiselectAjax from "@/components/inputs/filter/balancing-multiselect-ajax.vue";
import BalancingPaymentStatusSelect from "@/components/inputs/filter/balancing-payment-status-select.vue";
import BalancingPaymentMultiselectAjax from "@/components/inputs/filter/balancing-payment-multiselect-ajax.vue";
import BalancingStatusSelect from "@/components/inputs/filter/balancing-status-select.vue";
import SubProductMultiselect from "@/components/inputs/filter/sub-product-multiselect.vue";

export default {
  components: {
    CustomerTypeSelect,
    DatepickerRange,
    Datepicker,
    DeliveryOrderMultiselectAjax,
    DriverMultiselectAjax,
    FactoryMultiselectAjax,
    FarmerCustomerMultiselectAjax,
    LcsMultiselectAjax,
    LocalMarketSaleOrderMultiselectAjax,
    NumberRange,
    ProductServiceMultiselectAjax,
    PurchaseOrderMultiselectAjax,
    RangePrice,
    SaleOrderMultiselectAjax,
    SaleOrderTypeSelect,
    SupplierMultiselectAjax,
    TicketMultiselectAjax,
    TicketStatusSelect,
    TripMultiselectAjax,
    UserSelectAjax,
    VehicleMultiselectAjax,
    OdooPurchaseOrderStateSelect,
    OdooPurchaseOrderInvoiceStatusSelect,
    OdooSaleOrderStateSelect,
    OdooSaleOrderInvoiceStatusSelect,
    PartnerCustomerMultiselectAjax,
    ProcessingCustomerMultiselectAjax,
    PurchaseOrderPaymentStatusSelect,
    PurchasePaymentStatusSelect,
    SalesInvoicePaymentStatusSelect,
    SalesReportPaymentStatusSelect,
    BalancingMultiselectAjax,
    BalancingPaymentStatusSelect,
    BalancingPaymentMultiselectAjax,
    BalancingStatusSelect,
    SubProductMultiselect
  },
  props: {
    filterColumn: {
      type: Object
    }
  }
};
</script>

<style scoped>
.label-filter {
  font-weight: 500;
  font-size: 14px;
  color: #6c7589;
  margin-bottom: 5px;
}
</style>
